export default __webpack_public_path__ + "125e345a0230415481e2dbd38d12d39e.png";